import React from 'react';
import { motion } from 'framer-motion';
const emojiSets: Record<string, string[]> = {
  'Label Reading': ['🍋', '🍓', '🌿', '🫐', '🍊', '🥕'],
  'Ingredient Education': ['🧪', '🍯', '🌾', '🍎', '🧂', '🫙'],
  'Pregnancy Nutrition': ['🥑', '🐟', '🥦', '🍊', '🥛', '🌰'],
  'Family Nutrition': ['🍎', '🥕', '🧃', '🍌', '🥨', '🫐'],
  Nutrition: ['🥗', '🥑', '🫐', '🌾', '🥜', '🍅'],
  'Smart Shopping': ['🛒', '🏷️', '🥫', '🍞', '🥬', '🧀']
};
const defaultEmojis = ['🍎', '🥦', '🌿', '🍋', '🫐', '🥕'];
type FloatingFoodEmojisProps = {
  category?: string;
  emojis?: string[];
};
export function FloatingFoodEmojis({
  category,
  emojis
}: FloatingFoodEmojisProps) {
  const items = emojis ?? (category ? emojiSets[category] : undefined) ?? defaultEmojis;
  return <div aria-hidden="true" className="mb-10 flex flex-wrap items-center justify-center gap-3 sm:gap-5" data-id="element-90" data-mp="3dm7rm11wmun2">
      {items.map((emoji, index) => <motion.span key={`${emoji}-${index}`} className="flex h-12 w-12 items-center justify-center rounded-2xl border border-brand-100 bg-white text-2xl shadow-sm sm:h-14 sm:w-14 sm:text-3xl" animate={{
      y: [0, -8, 0]
    }} transition={{
      duration: 3.2 + index * 0.25,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: index * 0.18
    }} data-id="element-91" data-mp="1jbb36vaexzm3" data-mpi={index}>
          {emoji}
        </motion.span>)}
    </div>;
}
type EmojiListItem = {
  emoji: string;
  label: string;
  description?: string;
};
type EmojiListProps = {
  items: EmojiListItem[];
  columns?: 1 | 2 | 3;
};
export function EmojiList({
  items,
  columns = 2
}: EmojiListProps) {
  const columnClass = columns === 1 ? 'sm:grid-cols-1' : columns === 3 ? 'sm:grid-cols-3' : 'sm:grid-cols-2';
  return <ul className={`not-prose mb-8 grid list-none grid-cols-1 gap-3 p-0 ${columnClass}`} data-id="element-92" data-mp="hjm78wc6oov2">
      {items.map(item => <li key={item.label} className="flex items-start gap-3 rounded-2xl border border-slate-100 bg-white p-4 shadow-sm" data-id="element-93" data-mp="mhnodbq1ue3w">
          <span aria-hidden="true" className="text-2xl leading-none" data-id="element-94" data-mp="9ielrbqciske">
            {item.emoji}
          </span>
          <div data-id="element-95" data-mp="ofx5fzo62fkz">
            <p className="m-0 font-bold text-slate-900" data-id="element-96" data-mp="oggpblxdne1n">{item.label}</p>
            {item.description && <p className="m-0 mt-1 text-sm leading-relaxed text-slate-600" data-id="element-97" data-mp="jehnighacp6t">
                {item.description}
              </p>}
          </div>
        </li>)}
    </ul>;
}